import { RootStore } from "./rootStore";
import { observable, action } from "mobx";
import { TabList } from "../components/Tabs/Tabs";

export default class CommonStore {
  rootStore: RootStore;

  @observable isComparisonModalOpen = false;
  @observable isSideBarOpen = false;
  @observable currentTab = TabList[0].label;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @action setSideBarOpen = (isSidebarOpen: boolean) => {
    this.isSideBarOpen = isSidebarOpen;
  };

  @action setIsComparisonModalOpen = (isOpen: boolean) => {
    this.isComparisonModalOpen = isOpen;
  };

  @action setCurrentTab = (currentTab: string) => {
    this.currentTab = currentTab;
  }
}
